import { devNull } from "os";
import React, { useEffect, useRef, useState } from "react";

const useInterval = (callback: () => void, delay: number | null, ...deps) => {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback, ...deps]);

  useEffect(() => {
    if (delay === null) {
      return;
    }

    const tick = () => {
      savedCallback.current();
    };

    const id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay, ...deps]);
};

export default useInterval;
